import { REDUCER_NAME } from './constants';
import { getRootState } from '../selectors';

const getState = (state) => getRootState(state)[REDUCER_NAME];

export const getOrder = (state) => getState(state).order;

export const getIsFetching = (state) => getState(state).isFetching;

export const getOrderLoadingStatus = (state) => getState(state).orderFailedToLoad;

export const getLoadedCount = (state) => getState(state).loaded;

export const getIsNotifyingCustomers = (state) => getState(state).notifyingCustomers;

export const getIsAssigningOrders = (state) => getState(state).isAssigningOrders;

export const getIsAssignOrdersScreenOpened = (state) => getState(state).isAssignOrdersScreenOpened;

export const getSelectedShipments = (state) => getState(state).selectedShipments;

export const getIsCancelling = (state) => getState(state).isCancelling;
